module.exports = __webpack_public_path__ + "img/once_cn.54faf642.png";